import { useState } from "react";
import { message } from "antd";

// Reorder an ordered list by swapping two ADJACENT items via a single atomic server call
// (firstUid, secondUid → server swaps their `order` in one transaction). On failure it reloads so the
// UI re-syncs to server truth — no duplicated/inconsistent order can linger. Shared by the stages rail
// and the requirements accordion.
export function useOrderSwap<T extends { uid: string }>(
  items: readonly T[],
  reorder: (firstUid: string, secondUid: string) => Promise<void>,
  onChanged: () => void | Promise<void>,
) {
  const [busy, setBusy] = useState(false);

  function move(index: number, dir: "up" | "down"): void {
    const j = dir === "up" ? index - 1 : index + 1;
    if (busy || index < 0 || j < 0 || j >= items.length) return;
    setBusy(true);
    reorder(items[index].uid, items[j].uid)
      .then(() => onChanged())
      .catch(() => {
        message.error("Couldn't reorder");
        return onChanged();
      })
      .finally(() => setBusy(false));
  }

  return { move, busy };
}
